<template>
  <Header :islogin="dataStore.isLogin" :adiSoyadi="dataStore.adiSoyadi" :genelMudurlukAdi="dataStore.genelMudurlukAdi" />
  <router-view />
</template>


<script>
import { useStore } from "@/stores/store";
import Header from "./components/Header";

export default {
  name: 'App',
  components: { Header },
  data() {
    return {
      dataStore: useStore()
    }
  },
  created() {
    this.dataStore.getKullaniciBilgileri();
    this.dataStore.getGenelMudurlukler();
  }
}
</script>